<script setup>
import { ref, computed, reactive, onMounted } from "vue";
import { useRouter } from "vue-router";
import { getCurrentUser } from "vuefire";

const router = useRouter();

const props = defineProps({
  isEmbedded: Boolean,
});

onMounted(async () => {
    const currentUser = await getCurrentUser();
	if(!currentUser) {
        router.push({ name: "landing" });
    } else {
        router.push({ name: "dashboard" });
    }
});
</script>
